module.exports = __webpack_public_path__ + "media/images/icons/premium-2b017ee6c7e5d9ed22984199562b3688.svg";